import { Navigate, useLocation } from "react-router-dom";

// The Connect pages from before they were renamed to People. A connection's page is now a person's page.
export const ConnectRedirect = () => {
  const { pathname, search } = useLocation();
  const rest = pathname.replace(/^\/connect/, "").replace(/^\/connections\//, "/");

  return (
    <Navigate
      to={{ pathname: `/people${rest}`, search }}
      replace
    />
  );
};
